import React, { useEffect, useState } from 'react';

import { ExperienceTrackerContext } from '@confluence/experience-tracker/entry-points/component.ts';
import {
	/* eslint-disable-next-line no-restricted-imports */
	getExperienceTracker,
} from '@confluence/experience-tracker/entry-points/getExperienceTracker.ts';
import { getAnalyticsWebClient } from '@confluence/analytics-web-client';

import { initialization } from './initialization.ts';
import { SomethingWentWrong } from './SomethingWentWrong.tsx';
import { useExperienceFailureForRoute } from './useExperienceFailureForRoute.tsx';

type ErrorAppProps = ExperienceFailureForRootProps;

export const ErrorApp = ({ entryPoint, sessionDataError }: ErrorAppProps): React.JSX.Element => {
	const [isInitialized, setInitialized] = useState(false);

	useEffect(() => {
		void initialization().then(() => {
			setInitialized(true);
		});
	}, []);

	return (
		<ExperienceTrackerContext.Provider value={getExperienceTracker()}>
			<SomethingWentWrong />
			{isInitialized ? (
				<ExperienceFailureForRoot entryPoint={entryPoint} sessionDataError={sessionDataError} />
			) : null}
		</ExperienceTrackerContext.Provider>
	);
};

type ExperienceFailureForRootProps = {
	entryPoint?: string;
	sessionDataError?: Error;
};

const ExperienceFailureForRoot = ({
	entryPoint,
	sessionDataError,
}: ExperienceFailureForRootProps) => {
	useEffect(() => {
		void getAnalyticsWebClient().then((client) =>
			client.sendScreenEvent({
				name: 'standaloneErrorApp',
			}),
		);
	}, []);

	// eslint-disable-next-line no-restricted-syntax
	useExperienceFailureForRoute(window.location.href, entryPoint, sessionDataError);

	return null;
};
